import { FaPython, FaReact, FaNodeJs, FaDatabase, FaGamepad, FaShieldAlt, FaAndroid, FaDownload } from 'react-icons/fa';
import { SiFlask, SiExpress, SiMysql, SiPostgresql, SiLinux, SiYoutube } from 'react-icons/si';

// Importar imagens dos projetos
import climaImg from '../assets/images/climaimg.png';
import ipImg from '../assets/images/ipimg.png';
import landingPageImg from '../assets/images/landingpageimg.png';
import passwordGeneratorImg from '../assets/images/passworldgeneratorimg.png';
import loginImg from '../assets/images/loginimg.png';
import wordlistImg from '../assets/images/worldlistimg.png';
import dashboardImg from '../assets/images/dashboardimg.png';
import sarahImg from '../assets/images/sarahimg.png'; 

export const projectsData = [
  {
    id: 101,
    title: 'OmniTools — SaaS Micro-Tools Platform',
    description: 'Plataforma SaaS multi-utilitários para processamento de PDFs, mídias e conversões de arquivos em alta performance.',
    longDescription: 'SaaS completo com frontend Vercel Edge e backend distribuído (FastAPI, Redis, PostgreSQL, Celery worker cluster em VPS Linux). Suporta processamento massivo de arquivos, OCR, extração de tabelas, SEO técnico e assinaturas Pro.',
    category: 'fullstack',
    technologies: ['React', 'TypeScript', 'FastAPI', 'Python', 'Redis', 'PostgreSQL', 'Docker', 'Vercel'],
    status: 'completed',
    year: '2026',
    image: dashboardImg,
    demoUrl: 'https://omnitools-delta.vercel.app',
    githubUrl: 'https://github.com/IIBladeII',
    featured: true,
    features: [
      'Backend distribuído em cluster VPS',
      'Processamento de mídia e PDF em segundo plano',
      'SEO audit & otimização AdSense/Pro'
    ],
    icon: <FaPython />
  },
  {
    id: 102,
    title: 'MilSelect ERP Industrial B2B',
    description: 'Sistema ERP industrial completo para gestão comercial B2B, comissões de vendedores e relatórios operacionais.',
    longDescription: 'ERP para indústria de óleo de dendê e saneantes. Módulos de vendas por cidade/cliente, comissões em tempo real idênticas ao Excel comercial, controle de clientes e emissão documental.',
    category: 'fullstack',
    technologies: ['NestJS', 'React', 'Vite', 'PostgreSQL', 'Docker', 'Oracle Cloud ARM'],
    status: 'completed',
    year: '2026',
    image: dashboardImg,
    demoUrl: 'http://163.176.30.193:3000/login',
    githubUrl: 'https://github.com/IIBladeII',
    featured: true,
    features: [
      'Agrupamento inteligente por Cidade/Cliente',
      'Comissões sincronizadas em tempo real',
      'Deploy de produção em Oracle ARM VPS'
    ],
    icon: <FaDatabase />
  },
  {
    id: 103,
    title: 'Blade Console — AI Agent Control Plane',
    description: 'Painel web e orquestrador central de agentes autônomos com suporte a áudio local/nuvem e streaming de respostas.',
    longDescription: 'Plataforma desktop/web para orquestrar e monitorar a frota de agentes autônomos (Ultron, Ghost, Job-Search, etc.). Possui pipeline de voz STT/TTS (Whisper local + MiniMax), gerenciador de vagas e console interativo.',
    category: 'fullstack',
    technologies: ['FastAPI', 'React 18', 'Tailwind CSS', 'SQLite', 'Whisper', 'Python'],
    status: 'completed',
    year: '2026',
    image: dashboardImg,
    demoUrl: null,
    githubUrl: 'https://github.com/IIBladeII',
    featured: true,
    features: [
      'Orquestração multi-agente em tempo real',
      'Pipeline de voz STT/TTS integrado',
      'Suíte de testes automatizados (340+ testes)'
    ],
    icon: <FaShieldAlt />
  },
  {
    id: 104,
    title: 'Solar Atlas 3D — Astronomical Simulator',
    description: 'Simulador espacial 3D interativo do sistema solar com órbitas em tempo real e visualização de corpos celestes.',
    longDescription: 'Experiência web 3D imersiva construída com React Three Fiber e Three.js para renderizar sistemas planetários, posições orbitais e dados astronômicos de alta precisão.',
    category: 'frontend',
    technologies: ['React', 'Three.js', 'React Three Fiber', 'Vite', 'Tailwind CSS'],
    status: 'completed',
    year: '2026',
    image: climaImg,
    demoUrl: null,
    githubUrl: 'https://github.com/IIBladeII',
    featured: true,
    features: [
      'Renderização 3D WebGL em tempo real',
      'Cálculo de órbitas e física espacial',
      'Interface cyberpunk responsiva'
    ],
    icon: <FaGamepad />
  },
  {
    id: 1,
    title: 'Clima-Tempo BRASIL',
    description: 'Aplicação web para previsão do tempo, fornecendo informações detalhadas sobre clima, temperatura, umidade e condições climáticas em tempo real.',
    longDescription: `Aplicação web com React e Node.js para consultar previsão do tempo em tempo real por cidade.`,
    category: 'fullstack',
    technologies: ['React', 'Tailwind CSS', 'Node.js','Express.js', 'Vite', 'API de clima'],
    status: 'completed',
    year: '2025',
    image: climaImg,
    demoUrl: 'https://clima-tempo-br.vercel.app/',
    githubUrl: 'https://github.com/iibladeii',
    featured: true,
    features: [
      'Previsão em tempo real',
      'Dados de temperatura e umidade',
      'Busca por localidades'
    ],
    icon: <FaNodeJs />
  },
  {
    id: 2,
    title: 'Dashboard React Moderno',
    description: 'Interface administrativa moderna com React, TypeScript e integração com APIs backend.',
    longDescription: `Dashboard responsivo com gráficos, tabelas e integração com APIs.`,
    category: 'frontend',
    technologies: ['React', 'Vite', 'Tailwind CSS', 'Framer Motion', 'Recharts', 'Zustand', 'Lucide React'],
    status: 'completed',
    year: '2025',
    image: dashboardImg,
    demoUrl: null,
    githubUrl: 'https://github.com/IIBladeII/Dashboard-Moderno.git',
    featured: true,
    features: [
      'Gráficos interativos',
      'Tabelas com paginação',
      'Tema claro/escuro'
    ],
    icon: <FaReact />
  },
  {
    id: 3,
    title: 'IP-Location',
    description: 'Ferramenta web para rastrear e localizar endereços IP, fornecendo informações detalhadas como país, cidade, ISP e coordenadas geográficas.',
    longDescription: `Ferramenta web para consulta de informações detalhadas de endereços IP.`,
    category: 'fullstack',
    technologies: ['React', 'CSS', 'JavaScript', 'API','Styled Components'],
    status: 'completed',
    year: '2024',
    image: ipImg,
    demoUrl: 'https://ip-locations.vercel.app/',
    githubUrl: 'https://github.com/IIBladeII/ip-location.git',
    featured: true,
    features: [
      'Geolocalização por IP',
      'Informações de ISP',
      'Mapa com coordenadas'
    ],
    icon: <FaReact />
  },
  {
    id: 4,
    title: 'Landing Page',
    description: 'Landing page moderna e responsiva com animações suaves, formulário de contato e integração com redes sociais.',
    longDescription: `Landing page moderna e responsiva com animações e formulário de contato.`,
    category: 'frontend',
    technologies: ['HTML', 'CSS', 'JavaScript', 'Bootstrap'],
    status: 'completed',
    year: '2024',
    image: landingPageImg,
    demoUrl: null,
    githubUrl: 'https://github.com/IIBladeII/landingpage-dev.git',
    featured: false,
    features: [
      'Animações suaves',
      'Formulário de contato',
      'Integração com redes sociais'
    ],
    icon: <FaReact />
  },
  {
    id: 5,
    title: 'Password Generator',
    description: 'Gerador de senhas seguro e interativo com opções personalizáveis de comprimento, caracteres especiais, números e indicador de força da senha em tempo real.',
    longDescription: `Ferramenta avançada para gerar senhas seguras e personalizáveis, desenvolvida com JavaScript vanilla e React. Inclui validação em tempo real, indicador visual de força da senha, controles intuitivos e funcionalidade de cópia com um clique. Ideal para criar senhas robustas com diferentes níveis de complexidade.`,
    category: 'frontend',
    technologies: ['HTML5', 'CSS3', 'JavaScript', 'React', 'Responsive Design'],
    status: 'completed',
    year: '2024',
    image: passwordGeneratorImg,
    demoUrl: null,
    githubUrl: 'https://github.com/IIBladeII/Password-Generator.git',
    featured: false,
    features: [
      'Geração de senhas fortes e personalizáveis',
      'Controle de comprimento (1-30 caracteres)',
      'Opções de maiúsculas, números e símbolos',
      'Indicador visual de força da senha',
      'Cópia rápida para área de transferência',
      'Interface responsiva e intuitiva',
      'Validação em tempo real',
      'Demonstração interativa integrada'
    ],
    icon: <FaShieldAlt />
  },
  {
    id: 6,
    title: 'Login Page',
    description: 'Página de login moderna e interativa com validação em tempo real, alternância entre login/cadastro e design responsivo seguindo as melhores práticas de UX.',
    longDescription: `Página de login completa desenvolvida com HTML, CSS e JavaScript vanilla, implementando funcionalidades avançadas como validação de formulário em tempo real, alternância suave entre modos de login e cadastro, e feedback visual intuitivo para o usuário.`,
    category: 'frontend',
    technologies: ['HTML5', 'CSS3', 'JavaScript', 'Responsive Design'],
    status: 'completed',
    year: '2024',
    image: loginImg,
    demoUrl: null,
    githubUrl: 'https://github.com/IIBladeII/Login-Page.git',
    featured: false,
    features: [
      'Validação de formulário em tempo real',
      'Alternância entre login e cadastro',
      'Mostrar/ocultar senha com toggle',
      'Feedback visual de erros',
      'Design responsivo e moderno',
      'Animações suaves de transição',
      'Acessibilidade e usabilidade',
      'Demonstração interativa integrada'
    ],
    icon: <FaShieldAlt />
  },
  {
    id: 7,
    title: 'Wordlist Generator',
    description: 'A tool for generating custom wordlists for security testing. Allows combining personal information, dates and additional words.',
    longDescription: `Ferramenta para gerar wordlists personalizadas para testes de segurança, permitindo combinar informações pessoais, datas e palavras adicionais.`,
    category: 'frontend',
    technologies: ['HTML', 'CSS', 'JavaScript'],
    status: 'completed',
    year: '2024',
    image: wordlistImg,
    demoUrl: null,
    githubUrl: 'https://github.com/IIBladeII/WordlistGenerator.git',
    featured: false,
    features: [
      'Combinação de padrões',
      'Entrada de dados personalizada',
      'Exportação da lista gerada'
    ],
    icon: <FaReact />
  },
  {
    id: 8,
    title: 'Audio Player Android',
    description: 'Reprodutor de música moderno para Android desenvolvido em Java 17, com interface Material Design e funcionalidades avançadas de reprodução.',
    longDescription: `Aplicativo Android nativo para reprodução de música com interface moderna usando Material Design Components. Desenvolvido em Java 17 com suporte a reprodução em segundo plano, controles intuitivos e visualização de metadados completos.`,
    category: 'mobile',
    technologies: ['Java 17', 'Android SDK', 'Material Design', 'MediaPlayer API', 'Glide', 'AndroidX', 'ViewBinding', 'ViewModel'],
    status: 'in-progress',
    year: '2025',
    image: null, // Adicionar imagem quando disponível
    demoUrl: null,
    githubUrl: 'https://github.com/iibladeii', // Atualizar com URL específica quando disponível
    featured: true,
    features: [
      'Reprodução de áudio local',
      'Interface Material Design',
      'Controles de reprodução completos',
      'Visualização de metadados',
      'Barra de progresso interativa',
      'Lista de músicas com capas',
      'Reprodução em segundo plano',
      'Notificações de controle'
    ],
    icon: <FaAndroid />
  },
  {
    id: 9,
    title: 'YouTube Downloader',
    description: 'Aplicativo Python para download de vídeos do YouTube em múltiplos formatos (MP3/MP4) com diferentes qualidades e opções de conversão.',
    longDescription: `Ferramenta completa desenvolvida em Python para download e conversão de vídeos do YouTube. Suporta múltiplos formatos de saída, diferentes qualidades de vídeo e áudio, interface gráfica intuitiva e processamento em lote. Utiliza bibliotecas modernas para garantir downloads rápidos e confiáveis.`,
    category: 'desktop',
    technologies: ['Python 3.9+', 'yt-dlp', 'tkinter', 'FFmpeg', 'Requests', 'Threading', 'JSON', 'OS'],
    status: 'in-progress',
    year: '2025',
    image: null, // Adicionar imagem quando disponível
    demoUrl: null,
    githubUrl: 'https://github.com/iibladeii', // Atualizar com URL específica quando disponível
    featured: true,
    features: [
      'Download em MP3 e MP4',
      'Múltiplas qualidades (144p até 4K)',
      'Conversão automática de formatos',
      'Interface gráfica amigável',
      'Download de playlists completas',
      'Extração apenas do áudio',
      'Seleção de qualidade personalizada',
      'Progresso de download em tempo real',
      'Suporte a legendas',
      'Processamento em lote'
    ],
    icon: <FaPython />
  },
  {
    id: 10,
    title: 'Delivery Express',
    description: 'Plataforma de delivery para restaurantes e entregadores com rastreamento em tempo real, gerenciamento de pedidos e integração com gateways de pagamento.',
    longDescription: `Aplicação fullstack em desenvolvimento usando React no frontend e Node.js/Express no backend. Funcionalidades incluem cadastro de restaurantes, painel do entregador, rastreamento em tempo real via WebSocket, integração com Stripe e painel administrativo.`,
    category: 'fullstack',
    technologies: ['React', 'Tailwind CSS', 'Node.js', 'Express.js', 'PostgreSQL', 'Socket.io', 'Docker', 'Stripe API', 'Mapbox'],
    status: 'in-progress',
    year: '2025',
    image: null,
    demoUrl: null,
    githubUrl: 'https://github.com/iibladeii/delivery-express',
    featured: true,
    features: [
      'Rastreamento de entregas em tempo real',
      'Gerenciamento de pedidos para restaurantes',
      'Painel do entregador com rotas otimizadas',
      'Integração com gateway de pagamento (Stripe)',
      'Notificações em tempo real',
      'Deploy com Docker e CI/CD'
    ],
    icon: <FaNodeJs />
  },
  {
    id: 11,
    title: 'Sarah Portfolio',
    description: 'Portfólio profissional moderno desenvolvido para Sarah Praxedes, com foco em design responsivo, animações fluidas e performance otimizada.',
    longDescription: `Portfólio pessoal construído com React, Vite, Tailwind CSS e Framer Motion. Design clean e responsivo, animações suaves, deploy automatizado via Vercel.`,
    category: 'frontend',
    technologies: ['React', 'Vite', 'Tailwind CSS', 'Framer Motion', 'Responsive Design'],
    status: 'completed',
    year: '2026',
    image: sarahImg,
    demoUrl: 'https://sarahpraxedes.vercel.app/',
    githubUrl: 'https://github.com/IIBladeII/sarah-portfolio',
    featured: true,
    features: [
      'Design responsivo e moderno',
      'Animações fluidas com Framer Motion',
      'Performance otimizada',
      'Deploy automatizado via Vercel'
    ],
    icon: <FaReact />
  }
];

// Função para obter categorias dinamicamente dos projetos existentes
export const getAvailableCategories = () => {
  const categories = [...new Set(projectsData.map(project => project.category))];
  const categoryLabels = {
    'backend': 'Backend',
    'frontend': 'Frontend',
    'fullstack': 'Backend + Frontend',
    'mobile': 'Mobile',
    'desktop': 'Desktop'
  };

  const availableCategories = [
    { id: 'all', label: 'Todos', count: projectsData.length }
  ];

  categories.forEach(category => {
    const count = projectsData.filter(project => project.category === category).length;
    availableCategories.push({
      id: category,
      label: categoryLabels[category] || category,
      count
    });
  });

  return availableCategories;
};

export const projectCategories = getAvailableCategories();

export const getProjectsByCategory = (category) => {
  if (category === 'all') return projectsData;
  return projectsData.filter(project => project.category === category);
};

export const getFeaturedProjects = () => {
  return projectsData.filter(project => project.featured);
};

export const getProjectById = (id) => {
  return projectsData.find(project => project.id === parseInt(id));
};